export const PRICING_BUDGET_UPDATE_FORM_JIRA_KEY_UPDATE = "PRICING_BUDGET_UPDATE_FORM_JIRA_KEY_UPDATE";
export const PRICING_BUDGET_UPDATE_FORM_BUDGET_UPDATE = "PRICING_BUDGET_UPDATE_FORM_BUDGET_UPDATE";
export const PRICING_BUDGET_UPDATE_FORM_DEFAULT = "PRICING_BUDGET_UPDATE_FORM_DEFAULT";
export const PRICING_BUDGET_UPDATE_FORM_SUBMIT = "PRICING_BUDGET_UPDATE_FORM_SUBMIT";